import { memo, useRef } from 'react';
import FloatAnimation from './FloatAnimation';
import LightningAnimation from './LightningAnimation';

interface IconProps {
  className?: string;
}

// Cloud path used for both clip-path and visual rendering
const CLOUD_PATH =
  'M55.0684 22C67.2823 22 77.1836 31.9013 77.1836 44.1152C77.1836 44.5608 77.1695 45.0033 77.1436 45.4424H84.3457C93.6283 45.4424 101.154 52.9674 101.154 62.25C101.154 71.5325 93.6282 79.0576 84.3457 79.0576H34.8076C25.5251 79.0576 18.0002 71.5325 18 62.25C18 53.5784 24.5669 46.4402 32.999 45.5381C32.9691 45.0676 32.9531 44.5932 32.9531 44.1152C32.9531 31.9012 42.8544 22 55.0684 22Z';

function ThunderstormIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-thunderstorm"
    >
      <g filter="url(#filter0_d_thunderstorm)">
        <LightningAnimation delay={0.8} />
        {/* lightning */}
        <path
          d="M39 84.8085L47.6761 67L46.9102 78.8724H54L45.3239 98L46.2275 84.8085H39Z"
          fill="#FFA51F"
        />
      </g>
      {/* Cloud group - foreignObject and path animate together */}
      <g>
        <FloatAnimation />
        {/* Backdrop blur effect using foreignObject with clip-path */}
        <foreignObject x="-2" y="2" width="123.154" height="97.0576">
          <div
            // @ts-expect-error xmlns is valid for foreignObject content
            xmlns="http://www.w3.org/1999/xhtml"
            style={{
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              clipPath: 'url(#bgblur_thunderstorm_clip)',
              height: '100%',
              width: '100%',
            }}
          />
        </foreignObject>
        {/* Cloud overlay with semi-transparent fill */}
        <path d={CLOUD_PATH} fill="white" fillOpacity="0.7" />
      </g>
      <g filter="url(#filter2_d_thunderstorm)">
        <LightningAnimation />
        {/* lightning */}
        <path
          d="M60 79.2766L72.1465 54L71.0743 70.8511H81L68.8535 98L70.1185 79.2766H60Z"
          fill="#FFA51F"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_thunderstorm"
          x="23"
          y="51"
          width="47"
          height="63"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.852175 0 0 0 0 0.63208 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_thunderstorm"
          x="44"
          y="38"
          width="53"
          height="76"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.852175 0 0 0 0 0.63208 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        {/* Clip path for backdrop blur - offset to match foreignObject position */}
        <clipPath id="bgblur_thunderstorm_clip" transform="translate(2 -2)">
          <path d={CLOUD_PATH} />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(ThunderstormIcon);
